import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";

const JavaScriptLesson1 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">

    <h3><strong>History of Javascript</strong></h3>
        <p>JavaScript was created by Brendan Eich in 1995 while he was working at Netscape Communications Corporation. It  was initially named Mocha, then briefly LiveScript before finally becoming JavaScript.</p>
         <p>The main aim of Javascript was to bring interactivity to web pages within Netscape Navigator, one of the earliest web browsers.</p>

         <div class="alert alert-secondary" role="alert">
         <h4><strong>Timeline</strong></h4>
         <p>Here's a useful timeline:</p>
         <h4 class="text-dark">1995-1997: Early Years</h4>
         <ul>
         <li><strong>Birth of JavaScript:</strong> Brendan Eich developed JavaScript in 1995.</li>
         <li><strong>Netscape Navigator:</strong> JavaScript was introduced in Netscape Navigator 2.0 in 1995, bringing interactivity to the web.</li>
         <li><strong>Microsoft JScript:</strong> Microsoft developed a similar scripting language called JScript for its Internet Explorer browser.</li>
         </ul>
         <h4 class="text-dark">1997-2006: Standardization and Growth</h4>
         <ul>
         <li><strong>ECMAScript Specification:</strong> JavaScript's standardization effort resulted in the ECMAScript specification in 1997, which helped standardize the language's core features.</li>
         <li><strong>DOM and AJAX:</strong> The Document Object Model (DOM) and Asynchronous JavaScript and XML (AJAX) were key developments that significantly enhanced JavaScript's capabilities.</li>
         <li><stronng>Browser Wars:</stronng> Competing browsers (Netscape Navigator vs. Internet Explorer) had their own versions of JavaScript, causing compatibility issues.</li>
         </ul>
         <h4 class="text-dark">2006-2010: JavaScript Evolution</h4>
         <ul>
             <li><strong>ECMAScript 3:</strong> This version became widely adopted and remained the standard for many years.</li>
             <li><strong>Frameworks and Libraries:</strong> The emergence of popular libraries and frameworks like jQuery, Prototype, and Dojo helped simplify JavaScript development and cross-browser compatibility.</li>
            <li><strong>ECMAScript 4 Proposal:</strong> An ambitious update to the language that ultimately didn't get ratified due to disagreements and concerns over its complexity.</li>
         </ul>
         <h4 class="text-dark">2010-2015: ECMAScript 5 and Beyond</h4>
         <ul>
            <li><strong>ECMAScript 5:</strong> This version brought significant improvements and new features to JavaScript.</li>
            <li><strong>Node.js:</strong> Ryan Dahl introduced Node.js, allowing JavaScript to be used for server-side programming.</li>
            <li><strong>ECMAScript 6 (ES6) / ECMAScript 2015:</strong> A major update to JavaScript with new syntax, features like arrow functions, classes, modules, and more.</li>
         </ul>
        <h4 class="text-dark">2016-Present: Rapid Evolution and Standardization</h4>
        <ul>
            <li><strong>ECMAScript Updates:</strong> JavaScript undergoes regular updates, with ECMAScript 2016 (ES7), ECMAScript 2017 (ES8), and subsequent yearly releases introducing new functionalities and improvements.</li>
            <li><strong>Modern Tooling:</strong> Development tools and technologies like Babel, Webpack, and TypeScript further enhance JavaScript's capabilities and productivity.</li>
            <li><strong>React, Angular, Vue:</strong> The rise of powerful front-end frameworks/libraries has revolutionized web development.</li>
        </ul>
        </div>

        <div class="alert alert-secondary" role="alert">
        <h4><strong>Why Javascript?</strong></h4>
        <p>Javascript is a programming language that allows web pages to be dynamic. It has evolved from a simple scripting language for enhancing web pages to a versatile and powerful language used not only for front-end web development but also for server-side programming, mobile app development, game development, and more. </p>
        <p>Javascript is an interpreted language, which means that it doesn't need to be compiled:
        instead the interpreter (such as a web browser) will parse the written code and turn it into a code that their machine can read and execute &mdash; suitable for creating dynamic websites that can run on any browser on any computer!</p>
       <p>Beyond that, JavaScript is not only restricted to the browser. JavaScript runtimes, such as <b class="text-danger">Node.js</b> and <b class="text-danger">Deno</b> allow you to write, launch and serve requests on webservers.</p>
       </div>

       <div class="alert alert-secondary" role="alert">
       <h4><strong>Frameworks and Libraries</strong></h4>
       <h5>Difference Between Framework and Library</h5>
       <p>Both frameworks and libraries provide precoded support programs to develop complex software applications. However, while libraries target a specific functionality, while a framework tries to provide everything required to develop a complete application.</p>
       <p>Javascript frameworks and libraries are essential tools that simplify and enhance the process of building web applications. They provide pre-written code, components, and structures to expedite development and address common challenges. Here's an overview of some popular JavaScript frameworks and libraries:</p>
       </div>

        <div class="alert alert-secondary" role="alert">
        <h4 class="text-dark"><strong>JavaScript Frameworks:</strong></h4>
        <ol class="list-group list-group-numbered mb-4">
          <li class="list-group-item"><strong>React.js:</strong>
          <ul>
              <li>Developed by Facebook, React is a popular front-end library for building user interfaces. It employs a component-based architecture, allowing developers to create reusable UI components.</li>
          </ul>
          </li>
          <li class="list-group-item"><strong>Angular:</strong>
          <ul>
              <li>Developed by Google, Angular is a comprehensive front-end framework that facilitates building large-scale applications. It uses TypeScript and employs a modular structure with its own set of tools and features.</li>
          </ul>
          </li>
          <li class="list-group-item"><strong>Vue.js:</strong>
          <ul>
              <li>Vue.js is a progressive and lightweight JavaScript framework used for building UIs. It's known for its simplicity and ease of integration into existing projects.</li>
          </ul>
          </li>
          <li class="list-group-item"><strong>Svelte:</strong>
          <ul>
              <li>Svelte is a relatively newer framework that shifts a significant part of the work from the browser to the compilation stage, resulting in highly optimized and performant code.</li>
          </ul>
          </li>
           <li class="list-group-item"><strong>Ember.js:</strong>
           <ul>
               <li>Ember.js is an opinionated framework with built-in solutions for common development needs, offering a strong structure and conventions for scalable applications.</li>
           </ul>
           </li>
        </ol>
        </div>

        <div class="alert alert-secondary" role="alert">
        <h4 class="text-dark"><strong>JavaScript Libraries:</strong></h4>
        <ol class="list-group list-group-numbered mb-4">
          <li class="list-group-item"><strong>jQuery:</strong>
          <ul>
              <li>One of the most popular JavaScript libraries, jQuery simplifies HTML document traversal and manipulation, event handling, animations, and AJAX.</li>
          </ul>
          </li>
          <li class="list-group-item"><strong>D3.js:</strong>
          <ul>
              <li>D3.js (Data-Driven Documents) is primarily used for data visualization on the web. It provides powerful tools for creating interactive and dynamic data visualizations.</li>
          </ul>
          </li>
          <li class="list-group-item"><strong>Lodash:</strong>
          <ul>
              <li>Lodash is a utility library that provides a wide array of functions for manipulating and working with arrays, objects, strings, and more, offering optimized performance and consistency.</li>
          </ul>
          </li>
          <li class="list-group-item"><strong>Moment.js</strong>
          <ul>
              <li>Moment.js was widely used for date and time manipulation, formatting, and parsing. Its successors, like Luxon and date-fns, continue its legacy with improved APIs and smaller bundle sizes.</li>
          </ul>
          </li>
           <li class="list-group-item"><strong>RxJS:</strong>
           <ul>
               <li>RxJS is a reactive programming library that allows developers to work with asynchronous data streams, providing powerful tools for managing and transforming streams of events/data.</li>
           </ul>
           </li>
        </ol>
        </div>
        <p>This is by no means an exhaustive list as there are multiple other Javascript frameworks and libraries you can explore.</p>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson1
